import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import $ from 'jquery'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { CONFIG_DRAWER_TAB_ACTIVE_PATH, CONFIG_DRAWER_TAB_LOADED_PATH } from 'api/actions'
import * as Model from 'api/model'
import Groups from 'drawer/tabs/layers/groups/Groups'
import Profiles from 'drawer/tabs/layers/profiles/Profiles'
import LayerSearch from 'drawer/tabs/layers/search/LayerSearch'
// import SetInternalLayerVisibility from 'drawer/tabs/layers/utils/SetInternalLayerVisibility'

export const SELECTOR_TYPE_RADIO = 'SELECTOR_TYPE_RADIO'
export const SELECTOR_TYPE_CARET = 'SELECTOR_TYPE_CARET'
export const SELECTOR_TYPE_CHECKBOX = 'SELECTOR_TYPE_CHECKBOX'

const styles = theme => ({
  root: {},
  title: {
    fontSize: '1.25rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
    marginLeft: 20,
    paddingTop: 15,
    paddingBottom: 20
  }
})

class Layers extends React.Component {
  constructor (props) {
    super(props)

    $('.pozi-drawer-tabs-layers').on('click', function (evt) {
      Model.set('app.drawer.activetabid', 'layers')
    })
  }

  render () {
    const { classes, layersTabLoaded, layersTabVisible, printUIVisible } = this.props

    // console.debug('Layers render - legend layersTabLoaded?', layersTabLoaded, 'layersTabVisible?', layersTabVisible, 'printUIVisible?', printUIVisible)

    if (!layersTabLoaded) {
      return null
    }

    const LegendTitle = () => <div className={classes.title}>Legend</div>

    return (
      <div className={classes.root}>
        { printUIVisible && <LegendTitle /> }
        <Profiles />
        <LayerSearch />
        <Groups />
      </div>
    )
  }
}

Layers.propTypes = {
  classes: PropTypes.object.isRequired,
  layersTabLoaded: PropTypes.bool.isRequired,
  layersTabVisible: PropTypes.bool.isRequired,
  printUIVisible: PropTypes.bool
}

function mapStateToProps (state, ownProps) {
  const { printUIVisible } = state

  const layersTabLoadedPath = CONFIG_DRAWER_TAB_LOADED_PATH + '.layers'
  const layersTabLoaded = get(state.config, layersTabLoadedPath, false)
  const layersTabVisible = get(state.config, CONFIG_DRAWER_TAB_ACTIVE_PATH, '') === 'layers'

  return {
    layersTabLoaded,
    layersTabVisible,
    printUIVisible
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Layers)
  )
)
